import { useEffect } from 'react';
import { useSWRConfig } from 'swr';

/**
 * Revalidates all SWR keys whose string value includes the provided token
 * whenever the token changes.
 *
 * Mirrors the behavior of calling mutate with a key predicate and
 * `{ revalidate: true }`.
 *
 */
const useSWRRevalidateByIncludes = (token) => {
  const { mutate } = useSWRConfig();

  useEffect(() => {
    const revalidateMatchingKeys = async () => {
      await mutate(
        (key) => typeof key === 'string' && key.includes(String(token)),
        undefined,
        { revalidate: true },
      );
    };

    revalidateMatchingKeys();
  }, [token]);
};

export default useSWRRevalidateByIncludes;
